module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAG9JREFUKBVjYBj+gBHkRQMLBwUWJob7xHj3zz8GxQsnDjxgAikGMf79Y0gkpBGkBqQWpI4Zpvj5kwcXJKQVHjIyMgTAxJBpkKZzJw4sgInBNYIEcGlG1wRSi6IRm2ZsmkDqcAIjC4cEEMapYARIAACTrTNHTp60/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/ic_arrow_down.png
// module id = 1233
// module chunks = 0